
class CartBundleUpsell extends HTMLElement{
    constructor(){
        super();

        this.openModal();
        this.bundleUpsellSubmit();
    }

    openModal(){
        let self = this;
        let modalTriggerLinks = self.querySelector('.bundle-upsell__info-subheading > span');
        let modalTriggerImage = self.querySelector('.bundle-upsell__image');
        let modalTriggerNotice = self.querySelector('.bundle-upsell__notice');
        let modalTriggers = [modalTriggerLinks, modalTriggerImage, modalTriggerNotice]

        modalTriggers.forEach(trigger => {
            if (trigger) {
            trigger.addEventListener('click', () =>{
                MicroModal.show('BundleProductModal',{
                    disableFocus: true,
                    onShow: modal => {
                        document.body.classList.add('modal-open--no--scroll')
                        document.querySelector('.drawer--mini-cart').classList.add('modal-open--no--scroll')
                    },
                    onClose: modal => {
                        document.body.classList.remove('modal-open--no--scroll')
                        document.querySelector('.drawer--mini-cart').classList.remove('modal-open--no--scroll')
                    },
                  });
                 
                // MicroModal.show('BundleProductModal');
            })
        }
        });

        this.upsellProductGallery = this.querySelector('[data-product-upsell-gallery]');

        this.upsellProductGallerySwiper = new Swiper(this.upsellProductGallery, {
            loop: true,
            spaceBetween: 5,
            slidesPerView: 2,
            watchSlidesProgress: true,
            preloadImages: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                989: {
                    slidesPerView: 1,
                }
            }
        });

        this.productGallery();
    }

    bundleUpsellSubmit(){
        let self = this;
        let submitBtn = self.querySelector('.bundle-upsell__modal #addToCart');
        if (submitBtn) {
            submitBtn.addEventListener('click', () => {
                let cartItems = document.querySelector('#cart-mini-items');
                let bundleProduct = document.querySelector('.bundle-upsell__modal input[name="id"]').value;
                let bundleRegularProduct1 = JSON.parse(document.querySelector('.bundle-upsell__notice').getAttribute('data-bundle-product-1'));
                let bundleRegularProduct2 = JSON.parse(document.querySelector('.bundle-upsell__notice').getAttribute('data-bundle-product-2'));
                let bundleRegularProduct1Id = bundleRegularProduct1[0].id;
                let bundleRegularProduct2Id = bundleRegularProduct2[0].id;

                cartItems.querySelectorAll('cart-mini-item').forEach(item => {
                let itemId = item.getAttribute('data-product-id');

                bundleRegularProduct1.forEach(variant => {
                    if(variant.id == itemId){
                        bundleRegularProduct1Id = itemId
                    }
                });
                bundleRegularProduct2.forEach(variant => {
                    if(variant.id == itemId){
                        bundleRegularProduct2Id = itemId
                        }
                    });
                });
                MicroModal.close('BundleProductModal');

                let body = '{"updates":{"'+bundleRegularProduct1Id+'": 0,"'+bundleRegularProduct2Id+'": 0,"'+bundleProduct+'": 1}}';
                fetch(`${window.routes.cart_update_url}`, { ...fetchConfig(), body })
                .then((response) => response.json())
                .then((parsedState) => { 
                    document.querySelector('cart-mini').renderInnerHTML();
                })
                .catch((e) => { console.error(e);})
            })
        }

    }

    productGallery(){
        let self = this;

        let productSingleThumbnailsWrap = self.querySelector('[data-product-upsell-single-thumbnails]');
        let productSingleThumbnails = self.querySelectorAll('[data-product-upsell-single-thumbnail]');
        let productGalleryArrowNext = self.querySelector('.bundle-upsell-modal__thumbnails-arrow.arrow-next');
        let productGalleryArrowPrev = self.querySelector('.bundle-upsell-modal__thumbnails-arrow.arrow-prev');
        let productSingleGallery = self.querySelector('[data-product-upsell-gallery]');

        self.upsellProductGallerySwiper.on('slideChange', function () {
            let activeIndex = this.activeIndex
            productSingleThumbnails.forEach(trigger => {
                if(trigger.dataset.slideIndex == activeIndex){
                    trigger.classList.add('is--active');
                    productSingleThumbnailsWrap.scrollTo({top: trigger.offsetTop, behavior: 'smooth'});
                } else{
                    trigger.classList.remove('is--active');
                }
            })
        });

        self.upsellProductGallerySwiper.on('slideChangeTransitionEnd', function () {
            let lastSlide = productSingleGallery.querySelector('li:last-of-type');
            let activeSlide = productSingleGallery.querySelector('.swiper-slide-active');
            let activeSlideVideo = activeSlide.querySelector('video');
            let slideVideos = productSingleGallery.querySelectorAll('video');
            if(activeSlideVideo){
                activeSlideVideo.play();
                activeSlideVideo.muted = true;
            } else{
                slideVideos.forEach(video => {
                    video.pause();
                });
            }

        });
        

        productSingleThumbnails.forEach(thumbnail => {
            thumbnail.addEventListener("click", (e) =>{
                let clickedThumbnail = e.target.closest('[data-product-upsell-single-thumbnail]');
                let slideIndex = clickedThumbnail.dataset.slideIndex;
                this.updateActiveImage(slideIndex);
                this.playPauseVideo();
            });
        });

        if(productGalleryArrowNext){
            productGalleryArrowNext.addEventListener('click', () => {
                let currentSlide = productSingleThumbnailsWrap.querySelector('li.is--active')
                let nextSlide = currentSlide.nextSibling;
                let firstSlide = productSingleThumbnailsWrap.querySelector('li:first-of-type')
                if (nextSlide) {
                    let nextSlideIndex = nextSlide.dataset.slideIndex;
                    productSingleThumbnailsWrap.scrollTo({top: nextSlide.offsetTop, behavior: 'smooth'});
                    this.updateActiveImage(nextSlideIndex)
                }else{
                    let firstSlideIndex = firstSlide.dataset.slideIndex;
                    productSingleThumbnailsWrap.scrollTo({top: firstSlide.offsetTop});
                    this.updateActiveImage(firstSlideIndex)
                }
                this.playPauseVideo();
            })
        }
        if(productGalleryArrowPrev){
            productGalleryArrowPrev.addEventListener('click', () => {
                let currentSlide = productSingleThumbnailsWrap.querySelector('li.is--active')
                let prevSlide = currentSlide.previousSibling;
                if (prevSlide) {
                    let prevSlideIndex = prevSlide.dataset.slideIndex;
                    productSingleThumbnailsWrap.scrollTo({top: prevSlide.offsetTop, behavior: 'smooth'});
                    this.updateActiveImage(prevSlideIndex)
                }
                this.playPauseVideo();
            })
        }

    }
    updateActiveImage(index){
        let self = this;
        self.upsellProductGallerySwiper.slideTo(index, 0, false);
    }
    playPauseVideo(){
        let self = this;
        let productSingleGallery = self.querySelector('[data-product-upsell-gallery]');
        let activeSlide = productSingleGallery.querySelector('.swiper-slide-active');
        let activeSlideVideo = activeSlide.querySelector('video');
        let slideVideos = productSingleGallery.querySelectorAll('video');
        if(activeSlideVideo){
            activeSlideVideo.play();
            activeSlideVideo.muted = true;
        } else{
            slideVideos.forEach(video => {
                video.pause();
            });
        }
    }
    
}

customElements.define('cart-bundle-upsell', CartBundleUpsell);